__turbopack_context__.v({
  "knob": "Toggle-module-scss-module__Rp7nIW__knob",
  "label": "Toggle-module-scss-module__Rp7nIW__label",
  "toggle": "Toggle-module-scss-module__Rp7nIW__toggle",
  "track": "Toggle-module-scss-module__Rp7nIW__track",
});
